module.exports = __webpack_public_path__ + "assets/img/9.9b874782.jpg";